import { v4 as uuid } from 'uuid';
import {
    getLocationAPI,
} from './api';

async function getLocation () {
    const env = this.env;
    const apiKey = this.widgetSettings.apikey;

    const res = await getLocationAPI({
        apiKey,
        traceId: env.traceId,
        store: this,
    });
    this.location = res.data;
    this.observed.location = uuid();
}

export default getLocation;
